var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"defaultPic"},[_c('el-image',{staticStyle:{"width":"70vw","height":"84vh"},attrs:{"src":_vm.imgUrl,"fit":"fill"}})],1),_c('right-menu')],1)}
var staticRenderFns = []

export { render, staticRenderFns }